import config from 'config'

import useCurrentUser from './useCurrentUser'

export default function useProfilePath() {
  const user = useCurrentUser()

  const globalHandle = user.profile?.globalHandle

  return `${config.PROFILES_URL}/${globalHandle}`
}
